export function formatAddress(currentLocation: any) {
  const formattedAddressParts = [
    currentLocation?.unit_number && `${currentLocation.unit_number}-`,
    currentLocation?.street_address,
    currentLocation?.locality && `, ${currentLocation.locality}`,
    currentLocation?.administrative_division_1 &&
      `, ${currentLocation.administrative_division_1}`,
    currentLocation?.postal_code && ` ${currentLocation.postal_code}`,
    currentLocation?.country && ` ${currentLocation.country}`,
  ];

  return formattedAddressParts.filter(Boolean).join("");
}
